import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import AppShell from '../../../components/layout/AppShell';
import { apiRequest } from '../../../api/client';
import type { WorkOrderFormTemplate } from '../../../lib/workOrderForm';
import '../quotes/quote-generator.css';
import './work-order-forms.css';

export default function WorkOrderFormTemplatesList(): React.JSX.Element {
  const [templates, setTemplates] = useState<WorkOrderFormTemplate[]>([]);
  const [busy, setBusy] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    apiRequest<{ success: boolean; data: WorkOrderFormTemplate[] }>('/api/work-order-form-templates')
      .then((res) => setTemplates(res.data || []))
      .catch((e) => setError(e instanceof Error ? e.message : 'Failed to load templates'))
      .finally(() => setBusy(false));
  }, []);

  return (
    <AppShell>
      <div className="wo-form-page">
        <header className="tech-hero">
          <div>
            <p className="tech-kicker">Admin</p>
            <h1 className="tech-title">Work order forms</h1>
            <p className="tech-sub">Build reusable daily report templates technicians fill on assigned jobs.</p>
          </div>
          <div className="tech-actions">
            <Link to="/admin/work-order-forms/new" className="btn-primary">+ New Form Template</Link>
          </div>
        </header>

        {error ? <div className="banner banner-error">{error}</div> : null}
        {busy ? <p>Loading…</p> : null}

        <div className="wo-report-list">
          {templates.map((t) => (
            <div key={t._id} className="wo-report-row">
              <div>
                <strong>{t.name}</strong>
                <p className="tech-sub" style={{ margin: '4px 0 0' }}>
                  {t.sections?.length || 0} section(s) · {t.status || 'active'}
                </p>
              </div>
              <Link to={`/admin/work-order-forms/${t._id}`} className="btn-secondary">Edit</Link>
            </div>
          ))}
          {!busy && templates.length === 0 ? <p className="tech-sub">No templates yet.</p> : null}
        </div>
      </div>
    </AppShell>
  );
}
